export enum GROUP {
  UNIVERSALBAR_TOOLS = 'UniversalBar/Tools',
  TOOLS = 'tools',
  MEMBERSHIP = 'membership',
  PRODUCER_NOTIFICATION_BELL = 'ProducerNotificationBell'
}

export enum ENTITY {
  NOTIFICATION = 'notification'
}

export enum SYSTEM {
  CONSUMER_ENGAGEMENT = 'consumer_engagement'
}

export enum ACTION {
  METRIFY = 'metrify'
}
